import { StyleSheet, View } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import { Card } from '@/ui/Card'
import { TrendIndicator } from './TrendIndicator'

interface StatCardProps {
    label: string
    value: string
    changePercent?: number
}

export function StatCard({ label, value, changePercent }: StatCardProps) {
    const theme = useTheme()

    return (
        <View style={styles.wrapper}>
            <Card style={styles.card}>
                <View style={styles.content}>
                    <View style={styles.labelRow}>
                        <Text
                            variant="labelMedium"
                            style={{ color: theme.colors.onSurfaceVariant, flex: 1 }}
                            numberOfLines={1}
                        >
                            {label}
                        </Text>
                        {changePercent != null ? (
                            <TrendIndicator changePercent={changePercent} />
                        ) : null}
                    </View>
                    <Text variant="headlineMedium" style={{ color: theme.colors.onSurface }}>
                        {value}
                    </Text>
                </View>
            </Card>
        </View>
    )
}

const styles = StyleSheet.create({
    wrapper: {
        flex: 1,
    },
    card: {},
    content: {
        padding: 12,
        gap: 4,
    },
    labelRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
})
